import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
    uri: "https://api.prabel.pro/graphql",
    cache: new InMemoryCache()
});

export default client;